import '../styles/Navbar.css';
import React, { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { name: 'Landing', href: '/' },
  { name: 'Login', href: '/login' },
  { name: 'Shipments', href: '/shipments' },
  { name: 'Track Shipment', href: '/track-shipment' },
  { name: 'Admin', href: '/admin' },
];

function resolveHrefFromPath(pathname) {
  if (!pathname) return '';
  const match = NAV_ITEMS.find((item) => item.href === pathname);
  return match ? match.href : '';
}

function Navbar({ activePage = '' }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const normalizedPath =
    typeof window !== 'undefined' && window.location
      ? window.location.pathname
      : '';

  const resolvedHref = activePage
    ? (NAV_ITEMS.find((item) => item.name === activePage) || {}).href || ''
    : resolveHrefFromPath(normalizedPath);

  useEffect(() => {
    setMenuOpen(false);
  }, [activePage]);

  const isActive = (item) => resolvedHref !== '' && item.href === resolvedHref;

  return (
    <header className="nv-root">
      <div className="nv-bar">
        <a className="nv-brand" href="/" aria-label="Fast Forward Deliver Services — home">
          <span className="nv-pip" aria-hidden="true" />
          <span className="nv-brand-text">
            <span className="nv-brand-mark">Fast Forward</span>
            <span className="nv-brand-sub">Deliver Services</span>
          </span>
        </a>

        <nav className="nv-links" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.name}
              className={'nv-link' + (isActive(item) ? ' is-active' : '')}
              href={item.href}
              aria-current={isActive(item) ? 'page' : undefined}
            >
              {item.name}
            </a>
          ))}
        </nav>

        <button
          type="button"
          className="nv-menu-btn"
          aria-expanded={menuOpen}
          aria-controls="nv-mobile-panel"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M4 7h16M4 12h16M4 17h16"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>
      </div>

      {menuOpen && (
        <nav id="nv-mobile-panel" className="nv-panel" aria-label="Primary mobile">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.name}
              className={'nv-panel-link' + (isActive(item) ? ' is-active' : '')}
              href={item.href}
              aria-current={isActive(item) ? 'page' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}

export default Navbar;